<template>
    <div class="employee-profile ">
        <!-- <div class="blue-rectangle"></div>
        <div class="employee-picture">
            <img :src="employeeDetails.image && employeeDetails.image.url ? employeeDetails.image.url : require('../../assets/img/employee/default-image.png')"
                alt="employee">
        </div> -->
        <div class="container">

        <div class="col-md-12 col-12 p-0">
          <div class="employee-details">
            <div class="row m-0">
          <div class="col-md-4 col-12 ">

          <div class="employee-picture">
            <img :src="employeeDetails.image && employeeDetails.image.url ? employeeDetails.image.url : require('../../assets/img/employee/default-image.png')"
                alt="employee">
        </div>
        </div>
        <div class="col-md-8 col-12 ">
          <div class="employee-name"> {{ employeeDetails.name }}</div>
                <b-row class="mt-2">
                    <b-col>
                        <div class="info-label">المسمى الوظيفى</div>
                        <a href="mailto:test@example.com" class="employee-info">{{ employeeDetails.position  }}</a>
                    </b-col>
                    </b-row>
                <b-row class="mt-2">
                    <b-col>
                        <div class="info-label">البريد الالكترونى</div>
                        <a href="mailto:test@example.com" class="employee-info">{{ employeeDetails.email }}</a>
                    </b-col>
                    <b-col>
                        <div class="info-label">المؤهل العلمى</div>
                        <div class="employee-info">  {{ employeeDetails.graduation_university }}</div>
                    </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col>
                        <div class="info-label">الجنسية</div>
                        <div class="employee-info" v-if="employeeDetails.nationality">{{ employeeDetails.nationality.name }}</div>
                    </b-col>
                    <b-col>
                        <div class="info-label">الجنس</div>
                        <div class="employee-info">{{ employeeDetails.gender }}</div>
                    </b-col>
                </b-row>

        </div>

                <hr class="my-2">
                <div class="qr-code" @click="openModal">

                    <img src="../../assets/img/icon/qr-code-scan-icon.svg" class="ml-1" width="40px" alt="qr_code">
                    عرض الكود
                </div>
            </div>
        </div>
      </div>

    <!-- Modal for QR code -->
    <b-modal v-model="showModal" title="QR Code">
        <b-card>
      <div class="text-center">
        <!-- QR code display -->
       <div ref="qrCode">
        <b-col cols="12">
            <div class="w-100 conOfQrHead">
            <img src="../../assets/img/employee/qr-head.svg" class="ml-1" width="100%" alt="qr_code">
            <div class="qrImgEmployeeLogo">Logo</div>
            <img class="qrImgEmployee" :src="employeeDetails.image && employeeDetails.image.url ? employeeDetails.image.url : require('../../assets/img/employee/default-image.png')"/>
            <div class="qrEmployeeInfo">   <div class="employee-name"> {{ employeeDetails.name }}</div>
            </div>
        </div>
        </b-col>
        <b-col cols="12">
               <qrcode-vue  :value="generateQRCodeValue" :size="size" level="H" />
       </b-col>
       </div>
       <b-col cols="12" class="mt-2">

        <!-- Button to download QR code image -->
        <b-button @click="downloadQRCode" variant="primary">تحميل الصورة</b-button>
       </b-col>
      </div>
    </b-card>
    </b-modal>
        </div>
    </div>
</template>
<script>
  import QrcodeVue from 'qrcode.vue'
  import html2canvas from 'html2canvas';

export default {
    name: 'EmployeeDetails',
    components: {
      QrcodeVue,
    },
    data() {
      return {
        size: 300,
        showModal: false,

      }
    },
    computed: {
    generateQRCodeValue() {
      // Use the route params to dynamically generate the QR code value
      return `https://training.fci.group/employee/${this.$route.params.id}`;
    },
  },
    props:{
        employeeDetails:{
      type: Array,
      default: () => [],

    },


    },
    methods: {
    openModal() {
        console.log('enter');
      this.showModal = true;
    },
    async downloadQRCode() {
      // Use html2canvas to capture the QR code image
      const canvas = await html2canvas(this.$refs.qrCode);

      // Create a temporary link to download the image
      const link = document.createElement('a');
      link.href = canvas.toDataURL('image/png');
      link.download = 'qr_code.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

  },
}
</script>
<style lang="">

</style>
